
import {SxStyles} from "../../../types";
import theme from "../../../theme";

export const modalStyle: SxStyles = {
    modal: {
        '& .MuiBackdrop-root': {
            background: theme.palette.myPrimary?.white15,
            backdropFilter: 'blur(15px)',
        },
        '& .modal-wrapper': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: theme.palette.propVars?.borderRadius,
            maxHeight: '90vh',
            background: '#fff',
            '& .modal-header': {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                py: `calc(${theme.palette.propVars?.index} * 1.09)`,
                px: `calc(${theme.palette.propVars?.index} * 1.25)`,
                borderRadius: `${theme.palette.propVars?.borderRadius} ${theme.palette.propVars?.borderRadius} 0 0`,
                borderBottom: `1px solid  ${theme.palette.myPrimary?.lightBlue20}`,
                '& .title': {
                    color: theme.palette.neutral?.grey70,
                    fontWeight: 700,
                    lineHeight: `calc(${theme.palette.propVars?.index} * 0.933)`,
                    fontSize: `calc(${theme.palette.propVars?.index} * 0.657)`,
                },
                '& .close-btn': {
                    position: 'absolute',
                    right: '20px',
                    backgroundColor: "none",
                    color: theme.palette.neutral?.grey70,
                    '& svg': {
                        fill: theme.palette.neutral?.grey70,
                    },
                },
            },
        },
    },
};
